import { VehicleFilter } from '@autos/entities/vehicle-filter.response';
import { DiscountTypes } from '@app/entities/discount-types';
import { AirFiltersResponse, HotelFiltersResponse } from '@shared/magic-filter-bar/entities/filter-types';

export type FilterResponseUnion = VehicleFilter | AirFiltersResponse | HotelFiltersResponse;

export function mapFiltersReduce(filters: FilterResponseUnion, resultsCounts: number): FilterResponseUnion {
  const arrayProperties = Object.entries(filters);
  const filtersReduce = arrayProperties.map(([key, value]) => {
    if (Array.isArray(value) && value?.length === 1 && (value[0]['Count'] === resultsCounts || value[0]['Count'] === 0)) {
      return [key, []];
    }
    return [key, value];
  })
  return resultsCounts ? { ...Object.fromEntries(filtersReduce) } : filters;
}

export function isTagTypeisPrime(source: string, isPrime: boolean): boolean {
  if (source) {
    if (source.toLowerCase() === DiscountTypes.Prime.toLowerCase()) {
      return true;
    } else if (source.toLowerCase() === DiscountTypes.RappiCard.toLowerCase()) {
      return false;
    }
  }
  return isPrime;
}

export function isTagTypeisRappicard(source: string, hasRappiCard: boolean): boolean {
  return (source && source.toLowerCase() === DiscountTypes.RappiCard.toLowerCase()) || hasRappiCard;
}
